import { isFTTXConnection, OverallConnectionType } from 'Quotes/types/connectionType';
import Column from 'shared/components/atoms/Column';
import React from 'react';
import { ProductType } from 'Quotes/types/productTypes';
import { bearerForDisplay, formatBandwidth, fttxBandwidthForDisplay } from 'shared/utils/connectionCapacity';
import { formatBandwidthForSupplier } from 'shared/utils/connectionCapacity';
import { presentAccessMethodForSupplier } from 'Quotes/utils/supplierHelpers';
import { IPriceData, IQuote } from 'Quotes/types/store';
import { BearerType } from 'Quotes/QuoteBuilder/components/Configure/Bearer/BearerType';
import { cloudProviderForDisplay } from '../shared/utils/cloudProviderForDisplay';
import { Supplier } from 'Quotes/types/supplier';

export function Bandwidth(props: {
  connectionType: OverallConnectionType;
  selectedPrice: IPriceData;
  bandwidth: string;
  quote: IQuote;
  bearer: BearerType | undefined;
  productType: ProductType;
}) {
  const displayBandwidth = (bandwidth: string) => {
    if (props.selectedPrice.a_end_access_type === Supplier.ITS_FIBRELIGHT || props.selectedPrice.b_end_access_type === Supplier.ITS_FIBRELIGHT) {
      return `Bandwidth: ${formatBandwidthForSupplier(bandwidth, Supplier.ITS_FIBRELIGHT)}, ${presentAccessMethodForSupplier(Supplier.ITS_FIBRELIGHT, '', bandwidth)}`;
    }

    return `Bandwidth: ${formatBandwidth(bandwidth)}`;
  };

  const displayCapacity = () => {
    const bandwidth = props.selectedPrice.bandwidth || props.bandwidth;
    const speed = displayBandwidth(bandwidth);

    if (props.productType === ProductType.NNI2CCT) {
      return speed;
    }

    let CloudConnect = '';
    if (props.selectedPrice.cloud_connect?.provider && props.selectedPrice.cloud_connect?.bandwidth) {
      CloudConnect = `, Cloud Connect: ${cloudProviderForDisplay(props.selectedPrice.cloud_connect?.provider)}`;
      CloudConnect += ` at ${props.selectedPrice.cloud_connect.bandwidth >= 1000 ? `${props.selectedPrice.cloud_connect.bandwidth / 1000} Gbps` : `${props.selectedPrice.cloud_connect?.bandwidth} Mbps`}`;
    }

    return `Bearer: ${bearerForDisplay(props.bearer)}, ${speed}${CloudConnect}`;
  };

  const displayFttxCapacity = () => {
    if (!isFTTXConnection(props.quote.connectionType)) {
      return '';
    }

    if (props.quote.connectionType === 'EoFTTP' && !!props.selectedPrice.bandwidth) {
      return displayBandwidth(props.selectedPrice.bandwidth);
    }

    return fttxBandwidthForDisplay({
      aEndBandwidth: props.quote.aEndBandwidth,
      bEndBandwidth: props.quote.bEndBandwidth,
      connectionType: props.quote.connectionType,
    });
  };

  return (
    <Column defaultWidth={props.connectionType === 'Ethernet' ? 6 : props.connectionType === 'EoFTTP' ? 4 : 2}>
      <span className="bandwidth font-weight-bold" data-testid="order-summary-bandwidth">
        {props.connectionType === 'Ethernet' && displayCapacity()}
        {displayFttxCapacity()}
      </span>
    </Column>
  );
}
